import { useContext, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  navStepAtom,
  showEditPasswordModalAtom,
  userInfoAtom,
} from "src/atoms";
import { useLogout } from "src/hooks/api/auth/useLogout";
import { useRouter } from "src/hooks/useRouter";
import { getMyServiceList } from "src/service/console";
import { withdrawal } from "src/service/sessions";
import { update } from "src/service/user";
import { setUserInfoToLocalStorage } from "src/utils/storage/auth";
import {
  emailValidation,
  maxLengthValidation,
  passwordValidation,
} from "src/utils/validation";
import MyAccountUI from "./MyAccount.presenter";
import { ModalsDispatchContext } from "src/context/Modal/MyAccount/MyAccountModal.context";
import { useTranslation } from "react-i18next";

interface IMyAccountContainerProps {}
// 다시 만들것!!!
const MyAccountContainer = () => {
  const [modal, setModal] = useState({
    confirmEditName: false,
    confirmEditEmail: false,
    confirmEditPassword: false,
    confirmCancelMember: false,
    confirmWithDrawalMember: false,
  });

  const [showEditPassword, setShowEditPassword] = useRecoilState(
    showEditPasswordModalAtom
  );

  const [newUserName, setNewUserName] = useState<string>("");
  const [newEmail, setNewEmail] = useState<string>("");
  const [newEmailCheck, setNewEmailCheck] = useState<string>("");
  const [passwordCheck, setPasswordCheck] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordCheck, setNewPasswordCheck] = useState<string>("");
  const [newUserNameNoti, setNewUserNameNoti] = useState<string>("");
  const [newEmailNoti, setNewEmailNoti] = useState<string>("");
  const [newEmailCheckNoti, setNewEmailCheckNoti] = useState<string>("");
  const [passwordCheckNoti, setPasswordCheckNoti] = useState<string>("");
  const [newPasswordCheckNoti, setNewPasswordCheckNoti] = useState<string>("");
  const [confirmPasswordNoti, setConfirmPasswordNoti] = useState<string>("");

  const { setShowEditPasswordModal, setShowEditNameModal } = useContext(
    ModalsDispatchContext
  );
  const { t } = useTranslation();
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { goLogin } = useRouter();
  const { mutateLogout } = useLogout();
  useEffect(() => {
    setNavStep(0);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.target?.name) {
      case "newUserName":
        setNewUserName(e.target.value);
        break;
      case "newEmail": // 새 이메일 주소
        setNewEmail(e.target.value);
        break;
      case "newEmailCheck": // 이메일 주소 확인
        setNewEmailCheck(e.target.value);
        break;
      case "passwordCheck": // 비밀번호
        setPasswordCheck(e.target.value);
        break;
      case "newPassword": // 새 비밀번호
        setNewPassword(e.target.value);
        if (!passwordValidation(e.target.value)) {
          setNewPasswordCheckNoti(
            t("navBar.myAccount.popUp.changePassword.checkMsg4")
          );
        } else {
          setNewPasswordCheckNoti("");
        }
        break;
      case "newPasswordCheck": // 새 비밀번호 확인
        setNewPasswordCheck(e.target.value);
        break;
    }
  };

  const toggleModalEditName = () => {
    setShowEditNameModal((prev) => !prev);
  };

  const toggleModalEditEmail = () => {
    setModal((prev) => ({
      ...prev,
      confirmEditEmail: !prev.confirmEditEmail,
    }));
    setNewEmail("");
    setNewEmailCheck("");
    setPasswordCheck("");
    setNewEmailNoti("");
    setNewEmailCheckNoti("");
    setPasswordCheckNoti("");
  };

  const toggleModalEditPassword = () => {
    setShowEditPasswordModal((prev) => !prev);
    // setModal((prev) => ({
    //   ...prev,
    //   confirmEditPassword: !prev.confirmEditPassword,
    // }));
    // setPasswordCheck("");
    // setNewPassword("");
    // setNewPasswordCheck("");
    // setPasswordCheckNoti("");
    // setNewPasswordCheckNoti("");
    // setConfirmPasswordNoti("");
  };

  const toggleModalCancelMember = async () => {
    try {
      const eCoServiceList = await getMyServiceList({
        product: "WRAPSODY_ECO",
      });
      const wrapsodyServiceList = await getMyServiceList({
        product: "WRAPSODY",
      });

      if (eCoServiceList === null && wrapsodyServiceList === null) {
        setModal((prev) => ({
          ...prev,
          confirmWithDrawalMember: !prev.confirmWithDrawalMember,
        }));
      } else {
        let liveCount = 0;
        let endCount = 0;

        eCoServiceList &&
          eCoServiceList.forEach((service) => {
            liveCount++;
            if (service.payStatus === "END") {
              endCount++;
            }
          });
        wrapsodyServiceList &&
          wrapsodyServiceList.forEach((service) => {
            liveCount++;
            if (service.payStatus === "END") {
              endCount++;
            }
          });
        if (liveCount !== endCount) {
          setModal((prev) => ({
            ...prev,
            confirmCancelMember: !prev.confirmCancelMember,
          }));
        } else {
          setModal((prev) => ({
            ...prev,
            confirmWithDrawalMember: !prev.confirmWithDrawalMember,
          }));
        }
      }
    } catch (error: any) {
      if (error?.errorCode && error?.errorMessage) {
        alert(error.errorMessage);
      }
    }
  };

  const withDrawalMember = async () => {
    const result = await withdrawal({ userId: userInfo.userId });

    if (result) {
      await mutateLogout({});
      alert(t("navBar.myAccount.popUp.withDrawal.leaveOk"));
      goLogin();
    }
  };

  const confirmEditName = async () => {
    if (newUserName === "") {
      setNewUserNameNoti(t("navBar.myAccount.popUp.changeName.checkMsg1"));
      return;
    }

    if (newUserName.length < 3) {
      setNewUserNameNoti(t("navBar.myAccount.popUp.changeName.checkMsg2"));
      return;
    }

    if (newUserName.length > 50) {
      // 50자 이상 입력 불가
      // setNewUserNameNoti(t("logIn.signUp.nameCheckMsg", 50));
      return;
    }

    if (userInfo.userName === newUserName) {
      setNewUserNameNoti(t("navBar.myAccount.popUp.changeName.checkMsg3"));
      return;
    }

    setNewUserNameNoti("");

    const updUserInfo = {
      userName: "",
    };
    updUserInfo.userName = newUserName;

    const result = await update(updUserInfo);
    if (result) {
      // userInfo.userName = newUserName;
      alert(t("navBar.myAccount.popUp.changeName.checkMsg4"));
      setUserInfo((prev) => ({ ...prev, userName: newUserName }));
      // setUserInfoToLocalStorage(JSON.stringify(userInfo));
    } else {
      alert(t("navBar.myAccount.popUp.commonCheckMsg"));
    }

    toggleModalEditName();
  };

  const confirmEditEmail = async () => {
    if (newEmail === "") {
      setNewEmailNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg1"));
      return;
    }

    if (userInfo.userEmail === newEmail) {
      setNewEmailNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg4"));
      return;
    }

    if (!maxLengthValidation(newEmail, 50)) {
      // 50자 이상 입력 불가
      // setNewEmailNoti(t("logIn.signUp.emailCheckMsg", 50));

      return;
    }

    if (!emailValidation(newEmail)) {
      setNewEmailNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg3"));
      return;
    }

    setNewEmailNoti("");

    if (newEmailCheck === "") {
      setNewEmailCheckNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg2"));
      return;
    }

    if (newEmail !== newEmailCheck) {
      setNewEmailCheckNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg8"));

      return;
    }

    if (userInfo.userEmail === newEmail) {
      setNewEmailCheckNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg4"));

      return;
    }

    setNewEmailNoti("");
    setNewEmailCheckNoti("");

    if (passwordCheck === "") {
      setPasswordCheckNoti(t("navBar.myAccount.popUp.changeEmail.checkMsg7"));

      return;
    }

    setPasswordCheckNoti("");

    const updUserInfo = {
      userEmail: "",
      userPwd: "",
    };
    updUserInfo.userEmail = newEmail;
    updUserInfo.userPwd = passwordCheck;

    try {
      const result = await update(updUserInfo);
      if (result) {
        // userInfo.userEmail = newEmail;
        alert(t("navBar.myAccount.popUp.changeEmail.checkMsg5"));
        setUserInfo((prev) => {
          setUserInfoToLocalStorage(
            JSON.stringify({ ...prev, userEmail: newEmail })
          );
          return { ...prev, userEmail: newEmail };
        });
      } else {
        alert(t("navBar.myAccount.popUp.commonCheckMsg"));
      }
      toggleModalEditEmail();
    } catch (error: any) {
      if (error?.errorCode && error?.errorMessage) {
        if (error.errorCode === "NO_DATA") {
          alert(t("navBar.myAccount.popUp.changePassword.checkMsg5"));
        } else {
          alert(error.errorMessage);
          toggleModalEditEmail();
        }
      }
    }
  };

  const confirmEditPassword = async () => {
    if (passwordCheck === "") {
      setPasswordCheckNoti(
        t("navBar.myAccount.popUp.changePassword.checkMsg1")
      );

      return;
    }

    setPasswordCheckNoti("");

    if (newPassword === "") {
      setNewPasswordCheckNoti(
        t("navBar.myAccount.popUp.changePassword.checkMsg2")
      );

      return;
    }

    if (passwordCheck === newPassword) {
      setNewPasswordCheckNoti(
        t("navBar.myAccount.popUp.changePassword.usedPassword")
      );

      return;
    }

    setPasswordCheckNoti("");

    if (!passwordValidation(newPassword)) {
      setNewPasswordCheckNoti(
        t("navBar.myAccount.popUp.changePassword.checkMsg4")
      );

      return;
    }

    setNewPasswordCheckNoti("");

    if (newPasswordCheck === "") {
      setConfirmPasswordNoti(
        t("navBar.myAccount.popUp.changePassword.checkMsg3")
      );

      return;
    }

    if (newPassword !== newPasswordCheck) {
      setConfirmPasswordNoti(
        t("navBar.myAccount.popUp.changePassword.checkMsg5")
      );

      return;
    }

    setConfirmPasswordNoti("");

    const updUserInfo = {
      userPwd: "",
      newUserPwd: "",
    };
    updUserInfo.userPwd = passwordCheck;
    updUserInfo.newUserPwd = newPassword;

    try {
      const result = await update(updUserInfo);
      if (result) {
        alert(t("navBar.myAccount.popUp.changePassword.checkMsg6"));
      } else {
        alert(t("navBar.myAccount.popUp.commonCheckMsg"));
      }
      toggleModalEditPassword();
    } catch (error: any) {
      if (error?.errorCode && error?.errorMessage) {
        if (error.errorCode === "NO_DATA") {
          alert(t("navBar.myAccount.popUp.changePassword.checkMsg5"));
        } else {
          alert(error.errorMessage);
          toggleModalEditPassword();
        }
      }
    }
  };

  const confirmCancelMember = async () => {
    toggleModalCancelMember();
  };

  const confirmWithDrawalMember = async () => {
    toggleModalCancelMember();
  };

  return (
    <MyAccountUI
      modal={modal}
      handleChange={handleChange}
      toggleModalEditName={toggleModalEditName}
      toggleModalEditEmail={toggleModalEditEmail}
      toggleModalEditPassword={toggleModalEditPassword}
      toggleModalCancelMember={toggleModalCancelMember}
      confirmEditName={confirmEditName}
      confirmEditEmail={confirmEditEmail}
      confirmEditPassword={confirmEditPassword}
      confirmCancelMember={confirmCancelMember}
      newUserName={newUserName}
      newEmail={newEmail}
      newEmailCheck={newEmailCheck}
      newUserNameNoti={newUserNameNoti}
      newEmailNoti={newEmailNoti}
      newEmailCheckNoti={newEmailCheckNoti}
      passwordCheck={passwordCheck}
      passwordCheckNoti={passwordCheckNoti}
      newPasswordCheckNoti={newPasswordCheckNoti}
      confirmPasswordNoti={confirmPasswordNoti}
      withDrawalMember={withDrawalMember}
      confirmWithDrawalMember={confirmWithDrawalMember}
    />
  );
};

export default MyAccountContainer;
